export enum AuctionSortOrder {
  None,
  BidHighToLow,
  BidLowToHigh,
  EndSoonestFirst,
  EndLatestFirst,
  QuadkeyHighToLow,
  QuadkeyLowToHigh,
}
